import { render, staticRenderFns } from "./ConnectGaimin.vue?vue&type=template&id=0c84a200&scoped=true"
import script from "./ConnectGaimin.vue?vue&type=script&lang=js"
export * from "./ConnectGaimin.vue?vue&type=script&lang=js"
import style0 from "./ConnectGaimin.vue?vue&type=style&index=0&id=0c84a200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c84a200",
  null
  
)

export default component.exports